<template>
	<div class="InventoryManagement">
		<navbarv2 />
		<section class="s1">
			<div class="s1__container">
				<el-row>
					<el-col
						:xs="24"
						:sm="24"
						:md="10"
						:lg="10"
						:xl="10"
						class="s1__page_intro"
					>
						<h1 class="s1__page_title">
							Inventory Management
						</h1>
						<p>
							NymbleUp uses advance supply-chain techniques to maintain
							inventory and allow retailer to optimize inventory, keep a tighter
							control on the inventory and reduce wastage.
						</p>
					</el-col>
					<el-col
						:xs="24"
						:sm="24"
						:md="14"
						:lg="14"
						:xl="14"
						class="s1_image_section"
					>
						<img
							src="../../assets/images/Inventory Management.jpg"
							class="s1__small-image"
						/>
					</el-col>
				</el-row>
			</div>
		</section>
		<section class="s2 features-section-lead lead-section">
			<div class="s1__container">
				<h2>FEATURES</h2>
				<div class="s2__features_col">
					<el-row>
						<el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
							<div class="features-section">
								<div class="s2_feature_image">
									<img
										src="../../assets/images/FEATURES_icons/Demand_Planning.png"
									/>
								</div>
								<div class="s2_feature_text">
									<h4>Demand Planning</h4>
									<!-- <p>Increase revenue with smart upsell features like pop-up modifiers and assist the server with visual menus</p> -->
								</div>
							</div>
						</el-col>
						<el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
							<div class="features-section">
								<div class="s2_feature_image">
									<img
										src="../../assets/images/FEATURES_icons/Inventory_Optimization.png"
									/>
								</div>
								<div class="s2_feature_text">
									<h4>Inventory Optimization</h4>
									<!-- <p>Increase revenue with smart upsell features like pop-up modifiers and assist the server with visual menus</p> -->
								</div>
							</div>
						</el-col>
						<el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
							<div class="features-section">
								<div class="s2_feature_image">
									<img
										src="../../assets/images/FEATURES_icons/Inventory_Tracking.png"
									/>
								</div>
								<div class="s2_feature_text">
									<h4>Inventory Tracking</h4>
									<!-- <p>Increase revenue with smart upsell features like pop-up modifiers and assist the server with visual menus</p> -->
								</div>
							</div>
						</el-col>
						<el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
							<div class="features-section">
								<div class="s2_feature_image">
									<img
										src="../../assets/images/FEATURES_icons/Controlfoodcosts.png"
									/>
								</div>
								<div class="s2_feature_text">
									<h4>Control Food Costs</h4>
									<!-- <p>Increase revenue with smart upsell features like pop-up modifiers and assist the server with visual menus</p> -->
								</div>
							</div>
						</el-col>
					</el-row>
				</div>
			</div>
		</section>
		<RequestDemo />
		<footerbar />
	</div>
</template>

<script>
export default {
	name: "InventoryManagement",
	mixins: [],
	props: [],
	data() {
		return {};
	},
	methods: {}
};
</script>

<style lang="scss" scoped>
@import "./InventoryManagement.scss";
@import "./InventoryManagementM.scss";
</style>
